var map = {
	"./person-1.png": "c5/7",
	"./person-2.png": "/emX",
	"./person-3.png": "oD33"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "weSf";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/person\-.*\.png$
// module id = weSf
// module chunks = 1